<template>
    <div class="faq-card">
    <a-card  :bordered="false">
      <h2>FAQ 问题回答</h2>
      
      <div class="item">
            <h3>支付成功后，TRX什么时候到账？</h3>
            <p>平台地址接收到付款后，自动给打款地址返回TRX！</p>
        </div>
        <div class="item">
            <h3>订单可以撤回吗？</h3>
            <p>当您向平台账户支付费用后，订单不支持撤回。</p>
        </div>
        <div class="item">
            <h3>没有收到TRX/USDT兑换？</h3>
            <p>请您联系我们团队，我们会第一时间进行赔付补发。</p>
        </div>
    </a-card>
</div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        activeKey: []
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .faq-card {
    background: rgba(10, 26, 47, 0.9) !important;
    backdrop-filter: blur(10px);
    border-radius: 12px;
    padding: 20px;
    max-width: 800px;
    border: 1px solid rgba(255, 255, 255, 0.2);

    
    h2 {
      color: #00aaff;
      text-align: center;
      font-size: 1.5em;
      margin-bottom: 15px;
      text-shadow: 0 0 5px rgba(0, 170, 255, 0.3);
    }
    
    :deep(.ant-collapse) {
      background: transparent;
      border: none;
      
    }
      
  }

  .item {
        background: rgba(255, 255, 255, 0.15);
        border-radius: 12px;
        padding-left: 15px;
        margin-bottom: 10px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        transition: transform 0.3s ease;
    }

    .item:hover {
        transform: translateY(-3px);
    }
    .item h3 {
        color: #ffffff;
        font-size: 1em;
    }
    .item p {
        color: #d0d8e0;
        font-size: 0.85em;
    }
  </style>